<!-- <ng-container *ngIf="isDropTrailerEntry(); else content">
  <app-menu></app-menu>
</ng-container> -->
<!-- <ng-template #content> -->
  <app-menu>
  <div class="freightmancer-jr-content">
    <div class="step-content">
      <h1>Drop Trailer Entry Form</h1>
      <ul class="progress-bar">
        <li [class.active]="step === 1">
          <span class="icon"><i class="fas fa-building"></i></span>
          <span class="label">Customer and Carrier</span>
        </li>
        <li [class.active]="step === 2">
          <span class="icon"><i class="fas fa-truck-fast"></i></span>
          <span class="label">Shipper and Consignee</span>
        </li>
        <li [class.active]="step === 3">
          <span class="icon"><i class="fas fa-list"></i></span>
          <span class="label">Load Details</span>
        </li>
      </ul>
      <!-- Step 1: Customer and Carrier -->
      <div *ngIf="step === 1">
        <form [formGroup]="customerCarrierForm">
          <div class="section">
            <mat-card>
              <mat-card-header>
                <mat-card-title>Customer</mat-card-title>
              </mat-card-header>
              <mat-card-content class="form-field-container">
                <!-- Customer Organization Select -->
                <div class="flex-item-select">
                  <mat-form-field>
                    <mat-label>Customer</mat-label>
                    <mat-select formControlName="selectedCustomer" (selectionChange)="onCustomerSelected($event.value)">
                      <mat-option *ngFor="let customer of customers" [value]="customer">
                        {{ customer.contact_organization }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Customer Address Select -->
                <div class="flex-item-select">
                  <mat-form-field>
                    <mat-label>Customer Address</mat-label>
                    <mat-select formControlName="selectedCustomerAddressUuid">
                      <ng-container *ngIf="selectedCustomer; else noCustomer">
                        <mat-option *ngFor="let address of selectedCustomer.contact_addresses" [value]="address.contact_address_uuid">
                          {{ address.address_street }}, {{ address.address_locality }}, {{ address.address_region }}, {{ address.address_country }}
                        </mat-option>
                      </ng-container>
                      <ng-template #noCustomer>
                        <mat-option>Choose customer first</mat-option>
                      </ng-template>
                    </mat-select>
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="section">
            <mat-card>
              <mat-card-header>
                <mat-card-title>Carrier</mat-card-title>
              </mat-card-header>
              <mat-card-content class="form-field-container">
                <!-- Carrier Organization Select -->
                <div class="flex-item-select">
                  <mat-form-field>
                    <mat-label>Carrier</mat-label>
                    <mat-select formControlName="selectedCarrier" (selectionChange)="onCarrierSelected($event.value)">
                      <mat-option *ngFor="let carrier of carriers" [value]="carrier">
                        {{ carrier.contact_organization }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Carrier Address Select -->
                <div class="flex-item-select">
                  <mat-form-field>
                    <mat-label>Carrier Address</mat-label>
                    <mat-select formControlName="selectedCarrierAddressUuid">
                      <ng-container *ngIf="selectedCarrier; else noCarrier">
                        <mat-option *ngFor="let address of selectedCarrier.contact_addresses" [value]="address.contact_address_uuid">
                          {{ address.address_street }}, {{ address.address_locality }}, {{ address.address_region }}, {{ address.address_country }}
                        </mat-option>
                      </ng-container>
                      <ng-template #noCarrier>
                        <mat-option>Choose carrier first</mat-option>
                      </ng-template>
                    </mat-select>
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="freightmancer-jr-actions-container">
            <div class="freightmancer-jr-actions">
              <button mat-raised-button color="primary" (click)="nextStep()" [disabled]="customerCarrierForm.invalid">Next</button>
            </div>
          </div>
        </form>
      </div>
    
      <!-- Step 2: Shipper and Consignee -->
      <div *ngIf="step === 2">
        <form [formGroup]="shipperConsigneeForm">
          <div class="section">
            <mat-card>
              <mat-card-header>
                <mat-card-title>Shipper</mat-card-title>
              </mat-card-header>
              <mat-card-content class="form-field-container">
                <!-- Shipper Organization Select -->
                <div class="flex-item-select">
                  <mat-form-field>
                    <mat-label>Shipper</mat-label>
                    <mat-select formControlName="selectedShipper" (selectionChange)="onShipperSelected($event.value)">
                      <mat-option *ngFor="let shipper of shippers" [value]="shipper">
                        {{ shipper.contact_organization }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Shipper Address Select -->
                <div class="flex-item-select">
                  <mat-form-field>
                    <mat-label>Shipper Address</mat-label>
                    <mat-select formControlName="selectedShipperAddressUuid">
                      <ng-container *ngIf="selectedShipper; else noShipper">
                        <mat-option *ngFor="let address of selectedShipper.contact_addresses" [value]="address.contact_address_uuid">
                          {{ address.address_street }}, {{ address.address_locality }}, {{ address.address_region }}, {{ address.address_country }}
                        </mat-option>
                      </ng-container>
                      <ng-template #noShipper>
                        <mat-option>Choose shipper first</mat-option>
                      </ng-template>
                    </mat-select>
                  </mat-form-field>
                </div>
                  <!-- Pick-up Reference -->
                  <div class="flex-item">
                    <mat-form-field>
                      <mat-label>Pick-up Reference</mat-label>
                      <input matInput formControlName="pickUpReference">
                    </mat-form-field>
                  </div>
                  <!-- Pick-up Date and Time -->
                  <div class="flex-item">
                    <mat-form-field>
                      <mat-label>Pick-up Date</mat-label>
                      <input matInput [matDatepicker]="pickUpDatePicker" formControlName="pickUpDate" readonly>
                      <mat-datepicker-toggle matSuffix [for]="pickUpDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #pickUpDatePicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="flex-item">
                    <mat-form-field>
                      <mat-label>Pick-up Time</mat-label>
                      <input matInput type="time" formControlName="pickUpTime">
                    </mat-form-field>
                  </div>
                  <!-- Load Pieces -->
                  <div class="flex-item">
                    <mat-form-field>
                      <mat-label>Load Pieces</mat-label>
                      <input matInput type="number" min="0" formControlName="loadPieces">
                    </mat-form-field>
                  </div>
                    <!-- Note -->
                    <div class="flex-item-full">
                      <mat-form-field>
                        <mat-label>Note</mat-label>
                        <textarea matInput formControlName="pickUpNote"></textarea>
                      </mat-form-field>
                    </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="section">
            <mat-card>
              <mat-card-header>
                <mat-card-title>Consignee</mat-card-title>
              </mat-card-header>
              <mat-card-content class="form-field-container">
                <!-- Consignee Organization Select -->
                <div class="flex-item-select">
                  <mat-form-field>
                    <mat-label>Consignee</mat-label>
                    <mat-select formControlName="selectedConsignee" (selectionChange)="onConsigneeSelected($event.value)">
                      <mat-option *ngFor="let consignee of consignees" [value]="consignee">
                        {{ consignee.contact_organization }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Consignee Address Select -->
                <div class="flex-item-select">
                  <mat-form-field>
                    <mat-label>Consignee Address</mat-label>
                    <mat-select formControlName="selectedConsigneeAddressUuid">
                      <ng-container *ngIf="selectedConsignee; else noConsignee">
                        <mat-option *ngFor="let address of selectedConsignee.contact_addresses" [value]="address.contact_address_uuid">
                          {{ address.address_street }}, {{ address.address_locality }}, {{ address.address_region }}, {{ address.address_country }}
                        </mat-option>
                      </ng-container>
                      <ng-template #noConsignee>
                        <mat-option>Choose consignee first</mat-option>
                      </ng-template>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Delivery Reference -->
                <div class="flex-item">
                  <mat-form-field>
                    <mat-label>Delivery Reference</mat-label>
                    <input matInput formControlName="deliveryReference">
                  </mat-form-field>
                </div>
                <!-- Delivery Date and Time -->
                <div class="flex-item">
                  <mat-form-field>
                    <mat-label>Delivery Date</mat-label>
                    <input matInput [matDatepicker]="deliveryDatePicker" formControlName="deliveryDate" readonly>
                    <mat-datepicker-toggle matSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #deliveryDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="flex-item">
                  <mat-form-field>
                    <mat-label>Delivery Time</mat-label>
                    <input matInput type="time" formControlName="deliveryTime">
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="freightmancer-jr-actions-container">
            <div class="freightmancer-jr-actions">
              <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
              <button mat-raised-button color="primary" (click)="nextStep()" [disabled]="shipperConsigneeForm.invalid">Next</button>
            </div>
          </div>
        </form>
      </div>

      <!-- Step 3: Work Order Details -->
      <div *ngIf="step === 3">
        <form [formGroup]="workOrderDetailsForm">
          <div class="section">
            <mat-card>
              <mat-card-header>
                <mat-card-title>Load Details</mat-card-title>
              </mat-card-header>
              <mat-card-content class="form-field-container">
                <!-- Order Type Select -->
                <div class="flex-item-select">
                  <mat-form-field appearance="fill">
                    <mat-label>Order Type</mat-label>
                    <mat-select formControlName="orderType">
                      <mat-option *ngFor="let type of orderTypes" [value]="type.value">{{ type.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Customs Broker Select -->
                <div class="flex-item-select" *ngIf="workOrderDetailsForm.get('orderType')?.value > 2">
                  <mat-form-field appearance="fill">
                    <mat-label>Customs Broker</mat-label>
                    <mat-select formControlName="customBroker">
                      <mat-option *ngFor="let broker of customBrokers" [value]="broker.contact_uuid">{{ broker.contact_organization }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Packaging Type Checkboxes -->
                <div class="flex-item-select">
                  <label>Packaging Type</label>
                  <div formArrayName="packagingType" class="checkbox-group">
                    <mat-checkbox *ngFor="let item of packagingTypes; let i = index" [formControlName]="i">
                      {{ item }}
                    </mat-checkbox>
                  </div>
                </div>
                <!-- Trailer Number -->
                <div class="flex-item">
                  <mat-form-field appearance="fill">
                    <mat-label>Trailer Number</mat-label>
                    <input matInput formControlName="trailerNumber">
                  </mat-form-field>
                </div>
                <!-- Seal Number -->
                <div class="flex-item">
                  <mat-form-field appearance="fill">
                    <mat-label>Seal Number</mat-label>
                    <input matInput formControlName="sealNumber">
                  </mat-form-field>
                </div>
                <!-- Pick Number -->
                <div class="flex-item">
                  <mat-form-field appearance="fill">
                    <mat-label>Pick Number</mat-label>
                    <input matInput formControlName="pickNumber">
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="freightmancer-jr-actions-container">
            <div class="freightmancer-jr-actions">
              <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
              <button mat-raised-button color="primary" (click)="nextStep()" [disabled]="workOrderDetailsForm.invalid">Next</button>
            </div>
          </div>
        </form>
      </div>
    </div>
</div>
</app-menu>
<!-- </ng-template> -->